import { DemoCartridgeVariant } from '../model/demo.registration.model';

export const MOCK_DEMO_CARTRIDGE_VARIANT: DemoCartridgeVariant = {
  name: 'Counter Cartridge',
  cartridgeGroupKey: 'PROTOTYPE',
  usagePeriodInDays: 30,
  isDemo: true,
};
